import SvgIcon from "@mui/material/SvgIcon";

export default function MediaFire(props: any) {
  return (
    <SvgIcon {...props}>
      <g id="full_color_reversed">
        <g
          id="g1313"
          transform="matrix(0.20833334,0,0,0.20833334,1.9787834,2.0527708)"
        >
          <path
            id="flame"
            className="cls-1"
            d="m 27.121369,32.435649 a 67.142717,67.142717 0 0 1 12.17115,1.245519 c 3.794751,0.700523 7.631906,2.01924 11.51799,2.007236 2.969623,-0.0091 5.370635,-2.073126 5.362545,-4.610223 -0.0081,-2.537097 -2.421496,-4.586085 -5.391119,-4.576952 a 17.425923,17.425923 0 0 0 -5.083458,0.844177 c 0.427568,-0.316403 0.864531,-0.62015 1.312715,-0.906674 a 34.101089,34.101089 0 0 1 19.62013,-4.741482 c 7.327506,0.301138 14.965545,2.580937 20.568556,7.425103 A 25.953804,25.953804 0 0 1 95.83853,52.376096 25.76318,25.76318 0 0 1 80.016025,72.045676 31.307738,31.307738 0 0 1 61.162308,72.733804 C 53.05521,70.685338 45.974955,66.148182 38.349181,62.903646 A 61.138101,61.138101 0 0 0 24.555958,59.407815 l 0.0745,0.002 a 11.670646,11.670646 0 0 0 5.367634,-0.910067 c 2.253965,-1.08099 2.247441,-3.694415 1.071726,-5.601054 -1.397132,-2.265839 -4.212012,-3.19091 -6.644207,-3.849942 A 31.786583,31.786583 0 0 0 11.435729,48.410814 19.655489,19.655489 0 0 0 2.492543,51.587632 7.3940493,7.3940493 0 0 0 0.10184001,54.492801 C 4.125575,43.351363 12.111853,44.602754 17.017603,41.548191 a 2.8229689,2.8229689 0 0 0 -2.049771,-5.125862 9.4515182,9.4515182 0 0 0 -3.809886,1.905856 c -0.415956,0.317578 -0.786506,0.598361 -1.118305,0.848874 -2.61e-4,0 4.024387,-6.74141 17.081728,-6.74141 z"
            // style="stroke-width:1.30476"
            fill='#0070f0'
          />
          <path
            id="flame_center"
            data-name="flame center"
            className="cls-2"
            d="M 83.556609,46.910214 A 10.438957,10.438957 0 0 1 75.421198,59.231151 C 65.056873,61.348508 53.240355,52.743254 44.136424,48.538941 59.582902,49.475755 64.07113,40.232215 71.236195,38.774803 a 10.444437,10.444437 0 0 1 12.320414,8.135411 z"
            fill='white'
            // style="stroke-width:1.30476"
          />
        </g>
      </g>
    </SvgIcon>
  );
}
